module.exports = __webpack_public_path__ + "static/media/d7kz.1a470df4.pdf";